import Me from "../assets/img/me.webp";

import { Link } from "react-scroll";

const Hero = () => {
  return (
    <section
      id="home"
      className="min-h-screen flex items-center bg-primary py-24"
    >
      <div className="container mx-auto flex flex-col lg:flex-row items-center gap-16">
        {/* Texto */}
        <div className="flex-1 text-center lg:text-left">
          <p className="text-accent uppercase tracking-widest text-sm mb-6">
            Backend Developer
          </p>

          <h1 className="text-4xl md:text-6xl font-bold leading-tight mb-6">
            Diseño y construcción de sistemas
            <span className="block text-accent">
              escalables y estructurados
            </span>
          </h1>

          <p className="text-paragraph max-w-xl mb-10">
            Especializada en Java y TypeScript. Construyo backends robustos con
            arquitectura clara, control de acceso y trazabilidad desde el diseño
            inicial.
          </p>

          <Link to="portfolio" smooth duration={500}>
            <button className="bg-accent hover:bg-accent-hover px-8 py-3 font-medium transition-all">
              Ver proyectos
            </button>
          </Link>
        </div>

        {/* Imagen */}
        <div className="flex-1 flex justify-center relative">
          <div className="relative">
            <img
              src={Me}
              alt="Kimberly Blandon"
              className="w-72 object-contain relative z-10"
            />
            <div className="absolute inset-0 border border-accent/30 translate-x-4 translate-y-4 z-0"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
